export default {
  auto: '自动检测',
  zh: '中文',
  en: '英语',
  ja: '日语',
  ko: '韩语',
  fr: '法语',
  de: '德语',
  ru: '俄罗斯语',
  pt: '葡萄牙语',
  es: '西班牙语',
  ar: '阿拉伯语',
  th: '泰语',
  it: '意大利语',
  tr: '土耳其语',
  vi: '越南语',
  pl: '波兰语',
  he: '希伯来语',
  id: '印尼语',
  hi: '印地语',
  nl: '荷兰语',
  ms: '马来语',
  bn: '孟加拉语',
  ur: '乌尔都语',
  fa: '波斯语',
  cs: '捷克语',
  km: '高棉语',
  lo: '老挝语',
  my: '缅甸语',
  ceb: '宿务语',
  fil: '菲律宾语',
  yue: '粤语',

  translating: '翻译中...',
  showSource: '显示原文',
  reTranslate: '重新翻译',
  pageTranslate: '页面翻译',
  paragraphCompare: '段落对比',
  aliTranslate: '阿里翻译',
  source: '原文',
  target: '译文',
  paragraphLoading: '段落翻译中...',
} as const;
